<template>
    <div class="vertFlex">
        <div class="topbar">
            <img alt="school logo" :src="badgeIcon"  class="logo" @click="home()" v-if="showLogo && this.currentNav=='front'">
            <a  :href="backLogoURL" target="_blank"  v-if="showLogo && this.currentNav=='back'">
                <img alt="school logo" :src="badgeIcon_Back"  class="logo" >
            </a>
            
            <div class="" v-show="showHeader && showLocationName">
                <label class="menutitleText">{{toplabel}}</label>
            </div>
            <!-- <img alt="menu" src="@/assets/menu.svg"  class="menuimg" @click="toggleMenu()"> -->
            <div class="menuicondiv">
                <i class="material-icons menuimg" @click="toggleMenu()" v-if="loggedIn">menu</i>
            </div>
            
        </div>
        <div v-if="showMenu" class="menudiv">
            <div v-if="showHome">
                <a id="location" @click="home()" >
                    <span class="item" >Home</span>
                </a>
            </div>
            <div v-if="showRefresh">
                <a id="location" @click="refresh()" >
                    <span class="item" >Refresh</span>
                </a>
            </div>
            
            <div v-if="BadgeDesign.showTimeclock">
                <a  @click="timeclock()" >
                    <span class="item" >TimeClock</span>
                </a>
            </div>
            <div v-if="showDocument">
                <a  @click="documents()" >
                    <span class="item" >Documents</span>
                </a>
            </div>
            <div v-if="showPayAccount">
                <a  @click="payAccount()" >
                    <span class="item" >Pay Account</span>
                </a>
            </div>
            <div v-if="showAddFunds">
                <a  @click="addFunds()" >
                    <span class="item" >{{ addFundsName }}</span>
                </a>
            </div>
            <div v-for="menuitem in badgeData.MenuItemList" :key="menuitem.id" :value="menuitem.id" >
                <a id="location" :href="menuitem.websiteUrl" target="_blank">
                    <span class="item">{{menuitem.name}}</span>
                </a>
            </div>
            <div>
                <a  @click="logout()" >
                    <span class="item" >Logout</span>
                </a>
            </div>
        </div>
    </div>
    
</template>

<script>
import {mapFields} from 'vuex-map-fields'
export default {
    name:'badgeburgermenu',
    components:{
    },
    props:{
        toplabel:{
            type:String, 
        },
    },
    computed:{
        ...mapFields([
            'badgeData',
            'imageBasePath',
            'BadgeDesign',
            'loggedIn',
            'showHeader',
            'showMenu',
            'currentNav'
        ]),
        showLogo(){
            if(this.currentNav!='back'){return true}
            else if(this.showLogoBack){return true}
            else{return false}
        },
        showLogoBack(){
            if(window.SHOW_LOGO_BACK==undefined){return true}
            else{return window.SHOW_LOGO_BACK}
        },
        badgeIcon(){
            if(this.BadgeDesign==undefined){return './../' + window.SCHOOL_LOGO}


            return this.imageBasePath + this.BadgeDesign.badgeIcon
        },
        badgeIcon_Back(){
            if(this.BadgeDesign==undefined){return './../' + window.SCHOOL_LOGO}

            //if this is the back, and we have a back logo...use that
            if(this.logoBack!=''){
                return './../' + this.logoBack
            }

            return this.imageBasePath + this.BadgeDesign.badgeIcon
        },
        logoBack(){
            
            if(window.LOGO_BACK==undefined){return ''}
            else{return window.LOGO_BACK}
        },
        backLogoURL(){
            
            if(window.LOGO_BACK_URL==undefined){return ''}
            else{return window.LOGO_BACK_URL}
        },
        showDocument(){
            var oktoshow = true;
            if(window.SHOW_DOCUMENT_IN_MENU!=undefined){
                oktoshow=window.SHOW_DOCUMENT_IN_MENU=="True"
            }
            return this.BadgeDesign.showDocuments && oktoshow
        },
        showAddFunds(){
            if(window.MENU_SHOW_ADD_FUNDS==undefined){return false}
            else{return window.MENU_SHOW_ADD_FUNDS}
        },
        addFundsName(){
            if(window.MENU_FUNDING_NAME==undefined){return 'Add Funds'}
            else{return window.MENU_FUNDING_NAME}
        },
        showLocationName(){
            if(window.SHOW_LOCATION_NAME==undefined){return true}
            else{return window.SHOW_LOCATION_NAME}
        },
        showHome(){
            if(window.MENU_SHOW_HOME==undefined){return true}
            else{return window.MENU_SHOW_HOME}
        },
        showRefresh(){
            if(window.MENU_SHOW_REFRESH==undefined){return true}
            else{return window.MENU_SHOW_REFRESH}
        },


    },
    methods:{
        toggleMenu(){
            this.showMenu=!this.showMenu
        },
        home(){
            this.showMenu=false
            this.$emit('home')
        },
        refresh(){
            this.showMenu=false
            this.$emit('refresh')
            
        },
        timeclock(){
            this.showMenu=false
            this.$emit('time')
            
        },
        documents(){
            this.showMenu=false
            this.$emit('documents')
        },
        payAccount(){
            this.showMenu=false
            this.$emit('payaccount')
        },
        addFunds(){
            this.showMenu=false
            this.$emit('addfunds')
        },
        logout(){
            this.showMenu=false
            this.$emit('logout');
        }
    },
    data(){
        return{
            
            schoolLogoFilePath:'./../' + window.SCHOOL_LOGO,
            showPayAccount:window.MENU_SHOW_PAY_ACCOUNT,
            
        }
    }
}
</script>

<style>
.topbar{
    display:grid;
    grid-template-columns:1fr 1fr 1fr;

}
.menutitleText{
    font-weight: bold;
    color:var(--header-text-color);
 
}
.menudiv{
    margin:0px;
    padding:0px;
    text-align:right;
}
.menuicondiv{
    text-align: right;
    grid-column:3;
}
.menuimg{
    
    margin:0px;
    color:var(--header-text-color);
    font-size:xx-large;
}
.menuimg:hover{
    cursor:pointer;
}
.item{
    color:var(--menu-text-color);
    text-decoration-color: var(--menu-text-color);
    text-decoration: underline;
}
.item:hover{
    color:var(--menu-text-color);
    cursor:pointer;
}
.item:visited{
    color:var(--menu-text-color);
    cursor:pointer;
}
</style>
